import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-testimonial',
  templateUrl: './customer-testimonial.component.html',
  styleUrl: './customer-testimonial.component.scss'
})

export class CustomerTestimonialComponent implements OnInit {

  customerTestimonialList = [
    {
      id: 1,
      title: 'F M DENIM',
      pdf: 'assets/pdf/customer-testimonial/fmdenim.pdf'
    },
    {
      id: 2,
      title: 'ALC',
      pdf: 'assets/pdf/customer-testimonial/alc.pdf'
    },
    {
      id: 3,
      title: 'BHASKAR DENIM',
      pdf: 'assets/pdf/customer-testimonial/bhaskar-denim.pdf'
    }
  ];
  constructor() { }

  ngOnInit(): void {}

}
